import React from 'react';
import { FiAward, FiClock, FiStar, FiCalendar } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const DoctorAuthority = ({ image, name }) => {
  return (
    <section id="doctor" className="py-8 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Meet Your Healing Expert
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Experience world-class chiropractic care with Mumbai's most trusted pain relief specialist
          </p>
        </div>

        <div className="bg-gradient-to-br from-emerald-50 to-white rounded-3xl p-4 sm:p-8 lg:p-12 shadow-2xl border border-emerald-100">
          <div className="grid lg:grid-cols-2 gap-6 items-center">
            {/* Doctor Image - Updated to use uploaded file */}
            <div className="relative">
              <div className="bg-transparent p-0 rounded-t-2xl overflow-hidden sm:bg-white sm:rounded-2xl sm:p-2 sm:shadow-lg">
                <img
                  src={image || '/aboutImg2-.webp'}
                  alt={(name ? `${name} - Founder & Chief Chiropractor` : 'Dr. Saurabh Singh - Founder & Chief Chiropractor')}
                  className="w-full h-[350px] sm:h-72 lg:h-[600px] object-cover rounded-t-2xl sm:rounded-xl"
                  onError={(e) => {
                    // Fallback to a neutral professional photo if upload is missing
                    e.target.src = "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=500&h=600&fit=crop&crop=face";
                  }}
                />
                {/* Years Experience Badge (smaller on mobile) */}
                <div className="absolute bottom-3 left-3 sm:bottom-6 sm:left-6 bg-emerald-600 text-white rounded-lg px-3 py-1.5 sm:px-4 sm:py-2 shadow-lg text-sm sm:text-base">
                  <div className="text-lg font-bold">15+</div>
                  <div className="text-xs font-medium">Years Experience</div>
                </div>
              </div>
              <div className="hidden sm:block absolute -top-2 -right-2 sm:-top-4 sm:-right-4 bg-emerald-600 text-white rounded-lg p-2 sm:p-3 shadow-lg">
                <SafeIcon icon={FiAward} className="w-6 h-6" />
              </div>
            </div>

            {/* Doctor Info */}
            <div className="space-y-6">
              <div className="space-y-3">
                <h3 className="text-3xl lg:text-4xl font-bold text-gray-900">
                  {name || 'Dr. Saurabh Singh'}
                </h3>
                <p className="text-xl text-emerald-600 font-semibold">
                  Founder & Chief Chiropractor
                </p>
                <p className="text-lg text-gray-700 leading-relaxed">
                  With over 15 years of dedicated practice, Dr. Singh has transformed the lives of 30,000+ patients through his expertise in non-surgical pain management and holistic healing approaches.
                </p>
              </div>

              {/* Specializations */}
              <div className="space-y-4">
                <h4 className="text-xl font-semibold text-gray-900">Specialized Therapies:</h4>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {[
                    'Chiropractic Adjustments',
                    'Jiva Nadi Therapy',
                    'Spinal Decompression',
                    'Sports Injury Treatment',
                    'Neurological Rehabilitation',
                    'Postural Correction'
                  ].map((therapy, index) => (
                    <div key={index} className="flex items-center space-x-2 text-gray-700">
                      <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
                      <span>{therapy}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Scarcity CTA */}
              <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
                <div className="flex items-center space-x-3 mb-3">
                  <SafeIcon icon={FiCalendar} className="w-5 h-5 text-amber-600" />
                  <span className="font-semibold text-amber-800">Limited Daily Appointments</span>
                </div>
                <p className="text-amber-700 text-sm mb-4">
                  Dr. Singh personally limits consultations to ensure quality care for each patient.
                </p>
                <button className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 rounded-full font-semibold transition-all duration-300 shadow-lg hover:shadow-xl w-full sm:w-auto">
                  Consult Dr. Saurabh Today
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DoctorAuthority;